// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__YuZWp","navitem":"NavBar_navitem__F-IaR","navitemnolog":"NavBar_navitemnolog__flykV","flickering":"NavBar_flickering__NGW1Y"};